import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  private baseUrl: string = environment.baseApiUrl;

  constructor(private http: HttpClient) {}

  uploadFile = (fileRequest: any): Observable<HttpEvent<any>> => {
    return this.http.post<any>(`${this.baseUrl}/files/upload`, fileRequest, {
      reportProgress: true,
      observe: 'events',
    });
  };
}
